module.exports = __webpack_public_path__ + "static/media/rvt.66d61ac3.gif";